import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent {
  @Input() title: string = '';
  @Input() drawerBtn: string = '';
  @Input() positionClass: string = '';
}
